<div class="login-container">
    <div class="box">
        <span><img src= "./assets/images/suter.png"></span>
        <p class="mat-h1">{{name}}</p>
        <p class="mat-h3">Version: {{version}} {{'about.of' | translate}} {{date}}</p>
        <firebase-ui (signInSuccessWithAuthResult)="successfullLogin($event)"
            (signInFailure)="unSuccessfullLogin($event)" (uiShown)="uiShown()">
        </firebase-ui>
    </div>
</div>